import { useAppDispatch, useAppSelector } from "hooks";
import { useWebStoreContext } from "contexts";
import { featureTrackerAPI } from "redux/apis";
import { selectWebStoreState, onClosePopUp } from "redux/slices";
import { useRebateAnalytics } from "components/RebateOffer/hooks/useRebateAnalytics";
import { useEffect } from "react";
import { RebateOfferResponse } from "interfaces/rebate-offer";
import { useMediaQuery } from "@mui/material";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { FeatureType } from "interfaces/feature-tracker";

export const useRebateMainPopupLogic = () => {
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const isPortrait = useMediaQuery("(orientation: portrait)");

	const scale = useCalculateScale(
		isPortrait ? 380 + 40 : 1000 + 40,
		isPortrait ? 600 + 40 : 380 + 40
	);
	const { authToken } = useWebStoreContext();
	const { rewardTypes } = useAppSelector(selectWebStoreState).store;

	const { data: rebateOfferData }: { data?: RebateOfferResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.REBATE_OFFER,
			isAuthenticated: !!authToken?.value
		});

	const rewardType = rewardTypes?.find(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(type: any) => type.id === rebateOfferData?.rebateTracker?.inventoryType
	);

	const currentProgress =
		(rebateOfferData?.rebateTracker?.targetSpend ?? 0) -
		(rebateOfferData?.rebateTracker?.amountToNextEarn ?? 0);

	const { sendAnalytics } = useRebateAnalytics({
		offer: undefined,
		rebateTracker: rebateOfferData?.rebateTracker,
		nowTime,
		rewardType,
		currentProgress,
		source: location.pathname,
		eventType: "event_screen"
	});

	const handleOnEnd = () => {
		setTimeout(() => {
			onClose();
		}, 500);
	};

	const onClose = () => {
		sendAnalytics("event_screen_close");
		dispatch(onClosePopUp());
	};

	//* Analytics Reporting - View
	useEffect(() => {
		if (rebateOfferData?.rebateTracker) {
			sendAnalytics("event_screen_view");
		}
	}, [rebateOfferData?.rebateTracker]);

	return {
		rebateOfferData,
		rewardType,
		currentProgress,
		sendAnalytics,
		handleOnEnd,
		onClose,
		nowTime,
		scale,
		isPortrait
	};
};
